import { useTranslation } from 'react-i18next';

import {
  EmptyContainer,
  EMPTY_ILLUSTRATIONS,
  ExpandableTable,
  Typography,
  ICONS,
  Icon,
} from '@thinknet-gmbh/platform-common-ui';

import { TableDetailsItem } from './table-details-item';

import { MainTableContainer, TableRowEdit } from './applications-table.styles';
import { IApplicationSetting } from '../../applications.interfaces';

const ApplicationsTable = ({
  onClickEdit,
  collection,
}: {
  onClickEdit: (data: IApplicationSetting) => void;
  collection: IApplicationSetting[];
}) => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  return (
    <MainTableContainer>
      {collection?.length ? (
        <ExpandableTable
          t={t}
          dataSource={collection}
          expandedRowRender={application => <TableDetailsItem application={application} />}
        >
          <ExpandableTable.Column
            title={t('settings:applications.labels.type')}
            key="type"
            dataIndex="type"
            render={(_, record: any) => {
              return (
                <Typography>
                  {t(`settings:applications.labels.applicationTypes.${record.type.toLowerCase()}`)}
                </Typography>
              );
            }}
          />
          <ExpandableTable.Column
            width={50}
            render={(_, record: IApplicationSetting) => {
              return (
                <TableRowEdit
                  onClick={(e) => {
                    e.stopPropagation()
                    onClickEdit(record);
                  }}
                >
                  <Icon icon={ICONS.editAlt} />
                  <div>{t('common:buttons.edit')}</div>
                </TableRowEdit>
              );
            }}
          />
        </ExpandableTable>
      ) : (
        <EmptyContainer illustration={EMPTY_ILLUSTRATIONS.dataAnalysis} />
      )}
    </MainTableContainer>
  );
};

export default ApplicationsTable;
